export const variants = [
    {
        id: "exte_metallo_100",
        name: "Panca Exte 100 in Metallo",
        imageUrl:
            "/assets/furnishing_icons/Panca-Exte-100.svg",
        category: "exte",
        subCategory: "exte",
        type: "PancaExte",
        material: "metallo",
        width: 105,
        height: 42,
        widthCell: 4,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "exte_metallo_150",
        name: "Panca Exte 150 in Metallo",
        imageUrl:
            "/assets/furnishing_icons/Panca-Exte-150.svg",
        category: "exte",
        subCategory: "exte",
        type: "PancaExte",
        material: "metallo",
        width: 155,
        height: 42,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "exte_wpc_100",
        name: "Panca Exte 100 in WPC",
        imageUrl:
            "/assets/furnishing_icons/Panca-Exte-100.svg",
        category: "exte",
        subCategory: "exte",
        type: "PancaExte",
        material: "wpc",
        width: 105,
        height: 42,
        widthCell: 4,
        heightCell: 2,
        rotationStates: ['t','r'],
        details: "Dimensioni esterne: 105x42cm\nAltezza da terra: 55cm\nPeso: 17kg",
    },
    {
        id: "exte_wpc_150",
        name: "Panca Exte 150 in WPC",
        imageUrl:
            "/assets/furnishing_icons/Panca-Exte-150.svg",
        category: "exte",
        subCategory: "exte",
        type: "PancaExte",
        material: "wpc",
        width: 155,
        height: 42,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "ribassata_metallo",
        name: "Panca Exte Ribassata 150 in Metallo",
        imageUrl:
            "/assets/furnishing_icons/Panca-Exte-Ribassata-150.svg",
        category: "exte",
        subCategory: "exte_ribassata",
        type: "PancaExte",
        material: "metallo",
        width: 155,
        height: 42,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "ribassata_wpc",
        name: "Panca Exte Ribassata 150 in WPC",
        imageUrl:
            "/assets/furnishing_icons/Panca-Exte-Ribassata-150.svg",
        category: "exte",
        subCategory: "exte_ribassata",
        type: "PancaExte",
        material: "wpc",
        width: 155,
        height: 42,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "cover_wpc_150",
        name: "Panca Cover 150 in WPC",
        imageUrl:
            "/assets/furnishing_icons/Panca-Cover-150.svg",
        category: "cover",
        subCategory: "cover",
        type: "PancaCover",
        material: "wpc",
        width: 150,
        height: 57,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "cover_metallo_150",
        name: "Panca Cover 150 in Metallo",
        imageUrl:
            "/assets/furnishing_icons/Panca-Cover-150.svg",
        category: "cover",
        subCategory: "cover",
        type: "PancaCover",
        material: "metallo",
        width: 150,
        height: 57,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "cover_wpc_100",
        name: "Panca Cover 100 in WPC",
        imageUrl:
            "/assets/furnishing_icons/Panca-Cover-100.svg",
        category: "cover",
        subCategory: "cover",
        type: "PancaCover",
        material: "wpc",
        width: 100,
        height: 57,
        widthCell: 4,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "cover_metallo_100",
        name: "Panca Cover 100 in Metallo",
        imageUrl:
            "/assets/furnishing_icons/Panca-Cover-100.svg",
        category: "cover",
        subCategory: "cover",
        type: "PancaCover",
        material: "metallo",
        width: 100,
        height: 57,
        widthCell: 4,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "cover_skyline",
        name: "Panca Cover Skyline",
        imageUrl:
            "/assets/furnishing_icons/Panca-Skyline-150.svg",
        category: "cover",
        subCategory: "cover_skyline",
        type: "PancaCover",
        material: "metallo",
        width: 150,
        height: 50,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "seduta",
        name: "Seduta con vano contenitore",
        imageUrl:
            "/assets/furnishing_icons/Seduta-Con-Vano-Contenitore.svg",
        category: "seduta",
        subCategory: "seduta",
        type: "PancaCover",
        material: "metallo",
        width: 100,
        height: 57,
        widthCell: 4,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "cassapanca",
        name: "Cassapanca con vano contenitore",
        imageUrl:
            "/assets/furnishing_icons/Cassapanca-Con-Vano-Contenitore.svg",
        category: "seduta",
        subCategory: "cassapanca",
        type: "Cassapanca",
        material: "metallo",
        width: 150,
        height: 57,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "telaio_ruote_visibile_54x54",
        name: "Telaio con ruote 54x54",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-Fisse-Non-Girevoli-54x54.svg",
        category: "telaio_ruote",
        subCategory: "ruote_visibili",
        type: "Telaio",
        material: "metallo",
        width: 54,
        height: 54,
        widthCell: 2,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "telaio_ruote_visibile_104x104",
        name: "Telaio con ruote 104x104",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-Fisse-Non-Girevoli-104X104.svg",
        category: "telaio_ruote",
        subCategory: "ruote_visibili",
        type: "Telaio",
        material: "metallo",
        width: 104,
        height: 104,
        widthCell: 4,
        heightCell: 4,
        rotationStates: ['t','r'],
    },
    {
        id: "telaio_ruote_visibile_54x104",
        name: "Telaio con ruote 54x104",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-Fisse-Non-Girevoli-54x104.svg",
        category: "telaio_ruote",
        subCategory: "ruote_visibili",
        type: "Telaio",
        material: "metallo",
        width: 104,
        height: 54,
        widthCell: 4,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "telaio_ruote_visibile_54x154",
        name: "Telaio con ruote 54x154",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-Fisse-Non-Girevoli-54X154.svg",
        category: "telaio_ruote",
        subCategory: "ruote_visibili",
        type: "Telaio",
        material: "metallo",
        width: 154,
        height: 54,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "telaio_ruote_visibile_54x204",
        name: "Telaio con ruote 54x204",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-Fisse-Non-Girevoli-54X204.svg",
        category: "telaio_ruote",
        subCategory: "ruote_visibili",
        type: "Telaio",
        material: "metallo",
        width: 204,
        height: 54,
        widthCell: 8,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "telaio_ruote_scomparsa_54x54",
        name: "Telaio con ruote a scomparsa 54x54",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-A-Scomparsa-54x54.svg",
        category: "telaio_ruote",
        subCategory: "ruote_scomparsa",
        type: "Telaio",
        material: "metallo",
        width: 54,
        height: 54,
        widthCell: 2,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "telaio_ruote_scomparsa_104x104",
        name: "Telaio con ruote a scomparsa 104x104",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-A-Scomparsa-104X104.svg",
        category: "telaio_ruote",
        subCategory: "ruote_scomparsa",
        type: "Telaio",
        material: "metallo",
        width: 104,
        height: 104,
        widthCell: 4,
        heightCell: 4,
        rotationStates: ['t','r'],
    },
    {
        id: "telaio_ruote_scomparsa_54x104",
        name: "Telaio con ruote a scomparsa 54x104",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-A-Scomparsa-54x104.svg",
        category: "telaio_ruote",
        subCategory: "ruote_scomparsa",
        type: "Telaio",
        material: "metallo",
        width: 104,
        height: 54,
        widthCell: 4,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "telaio_ruote_scomparsa_54x154",
        name: "Telaio con ruote a scomparsa 54x154",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-A-Scomparsa-54X154.svg",
        category: "telaio_ruote",
        subCategory: "ruote_scomparsa",
        type: "Telaio",
        material: "metallo",
        width: 154,
        height: 54,
        widthCell: 6,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "telaio_ruote_scomparsa_54x204",
        name: "Telaio con ruote a scomparsa 54x204",
        imageUrl: "/assets/furnishing_icons/Telai-Con-Ruote-A-Scomparsa-54X204.svg",
        category: "telaio_ruote",
        subCategory: "ruote_scomparsa",
        type: "Telaio",
        material: "metallo",
        width: 204,
        height: 54,
        widthCell: 8,
        heightCell: 2,
        rotationStates: ['t','r'],
    },
    {
        id: "p_frangivista_100_inox",
        name: "Pannello Frangivista 100 in Acciaio Inox",
        imageUrl: "/assets/furnishing_icons/Pannello-Frangivista.svg",
        category: "pannelli_grigliati",
        subCategory: "pannello_frangivista",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        size_string: "100cm",
        width: 90.5,
        widthCell: 4,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "p_frangivista_100_zin",
        name: "Pannello Frangivista 100 in Metallo Zincato e Verniciato",
        imageUrl: "/assets/furnishing_icons/Pannello-Frangivista.svg",
        category: "pannelli_grigliati",
        subCategory: "pannello_frangivista",
        material: "metallo",
        type: "PannelliGrigliati",
        size_string: "100cm",
        width: 90.5,
        widthCell: 4,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "p_frangivista_150_inox",
        name: "Pannello Frangivista 150 in Acciaio Inox",
        imageUrl: "/assets/furnishing_icons/Pannello-Frangivista.svg",
        category: "pannelli_grigliati",
        subCategory: "pannello_frangivista",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        size_string: "150cm",
        width: 140.5,
        widthCell: 6,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "p_frangivista_150_zin",
        name: "Pannello Frangivista 150 in Metallo Zincato e Verniciato",
        imageUrl: "/assets/furnishing_icons/Pannello-Frangivista.svg",
        category: "pannelli_grigliati",
        subCategory: "pannello_frangivista",
        material: "metallo",
        type: "PannelliGrigliati",
        size_string: "150cm",
        width: 140.5,
        widthCell: 6,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "p_frangivista_200_inox",
        name: "Pannello Frangivista 200 in Acciaio Inox",
        imageUrl: "/assets/furnishing_icons/Pannello-Frangivista.svg",
        category: "pannelli_grigliati",
        subCategory: "pannello_frangivista",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        size_string: "200cm",
        width: 190.5,
        widthCell: 8,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "p_frangivista_200_zin",
        name: "Pannello Frangivista 200 in Metallo Zincato e Verniciato",
        imageUrl: "/assets/furnishing_icons/Pannello-Frangivista.svg",
        category: "pannelli_grigliati",
        subCategory: "pannello_frangivista",
        material: "metallo",
        type: "PannelliGrigliati",
        size_string: "200cm",
        width: 190.5,
        widthCell: 8,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "p_frangisole_100",
        name: "Pannello Frangisole 100 in WPC",
        imageUrl: "/assets/furnishing_icons/Pannello-Frangisole.svg",
        category: "pannelli_grigliati",
        subCategory: "pannello_frangisole",
        material: "wpc",
        type: "PannelliGrigliati",
        width: 96,
        widthCell: 4,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "p_frangisole_150",
        name: "Pannello Frangisole 150 in WPC",
        imageUrl: "/assets/furnishing_icons/Pannello-Frangisole.svg",
        category: "pannelli_grigliati",
        subCategory: "pannello_frangisole",
        material: "wpc",
        type: "PannelliGrigliati",
        width: 146,
        widthCell: 6,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "p_frangisole_200",
        name: "Pannello Frangisole 200 in WPC",
        imageUrl: "/assets/furnishing_icons/Pannello-Frangisole.svg",
        category: "pannelli_grigliati",
        subCategory: "pannello_frangisole",
        material: "wpc",
        type: "PannelliGrigliati",
        width: 196,
        widthCell: 8,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "supporti_vetro_100",
        name: "Supporti per pannello in vetro 100 in Acciaio Inox",
        imageUrl: "/assets/furnishing_icons/Supporto-Pannello-Vetro.svg",
        category: "pannelli_grigliati",
        subCategory: "supporti_vetro",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        width: 90.5,
        widthCell: 4,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "supporti_vetro_150",
        name: "Supporti per pannello in vetro 150 in Acciaio Inox",
        imageUrl: "/assets/furnishing_icons/Supporto-Pannello-Vetro.svg",
        category: "pannelli_grigliati",
        subCategory: "supporti_vetro",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        width: 140.5,
        widthCell: 6,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "supporti_vetro_200",
        name: "Supporti per pannello in vetro 200 in Acciaio Inox",
        imageUrl: "/assets/furnishing_icons/Supporto-Pannello-Vetro.svg",
        category: "pannelli_grigliati",
        subCategory: "supporti_vetro",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        width: 190.5,
        widthCell: 8,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "grigliati_fili_100",
        name: "Grigliato Fili 100 in Acciaio",
        imageUrl: "/assets/furnishing_icons/Grigliato-Fili-Acciaio.svg",
        category: "pannelli_grigliati",
        subCategory: "grigliati_fili",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        width: 90.5,
        widthCell: 4,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "grigliati_fili_150",
        name: "Grigliato Fili 150 in Acciaio",
        imageUrl: "/assets/furnishing_icons/Grigliato-Fili-Acciaio.svg",
        category: "pannelli_grigliati",
        subCategory: "grigliati_fili",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        width: 140.5,
        widthCell: 6,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "grigliati_fili_200",
        name: "Grigliato Fili 200 in Acciaio",
        imageUrl: "/assets/furnishing_icons/Grigliato-Fili-Acciaio.svg",
        category: "pannelli_grigliati",
        subCategory: "grigliati_fili",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        width: 190.5,
        widthCell: 8,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "grigliati_rete_100",
        name: "Grigliato Rete 100 in Acciaio Inox",
        imageUrl: "/assets/furnishing_icons/Grigliato-Rete-Acciaio.svg",
        category: "pannelli_grigliati",
        subCategory: "grigliati_rete",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        width: 90.5,
        widthCell: 4,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "grigliati_rete_150",
        name: "Grigliato Rete 150 in Acciaio Inox",
        imageUrl: "/assets/furnishing_icons/Grigliato-Rete-Acciaio.svg",
        category: "pannelli_grigliati",
        subCategory: "grigliati_rete",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        width: 140.5,
        widthCell: 6,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "grigliati_rete_200",
        name: "Grigliato Rete 200 in Acciaio Inox",
        imageUrl: "/assets/furnishing_icons/Grigliato-Rete-Acciaio.svg",
        category: "pannelli_grigliati",
        subCategory: "grigliati_rete",
        material: "acciaio_inox",
        type: "PannelliGrigliati",
        width: 190.5,
        widthCell: 8,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "pergodomino_01_plastica",
        name: "Pergodomino 01 54x54 h55 in Plastica",
        imageUrl: "/assets/furnishing_icons/PergoDomino-54X54.svg",
        category: "pergodomino",
        subCategory: "pergodomino_01",
        type: "PergoDomino",
        material: "plastica",
        width: 54,
        height: 54,
        widthCell: 2,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "pergodomino_01_metallo",
        name: "Pergodomino 01 54x54 h55 in Metallo",
        imageUrl: "/assets/furnishing_icons/PergoDomino-54X54.svg",
        category: "pergodomino",
        subCategory: "pergodomino_01",
        type: "PergoDomino",
        material: "metallo",
        width: 54,
        height: 54,
        widthCell: 2,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "pergodomino_02_plastica",
        name: "Pergodomino 02 54x54 h80 in Plastica",
        imageUrl: "/assets/furnishing_icons/PergoDomino-54X54.svg",
        category: "pergodomino",
        subCategory: "pergodomino_02",
        type: "PergoDomino",
        material: "plastica",
        width: 54,
        height: 54,
        widthCell: 2,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "pergodomino_02_metallo",
        name: "Pergodomino 02 54x54 h80 in Metallo",
        imageUrl: "/assets/furnishing_icons/PergoDomino-54X54.svg",
        category: "pergodomino",
        subCategory: "pergodomino_02",
        type: "PergoDomino",
        material: "metallo",
        width: 54,
        height: 54,
        widthCell: 2,
        heightCell: 2,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "pergodomino_03_plastica",
        name: "Pergodomino 03 79x79 h55 in Plastica",
        imageUrl: "/assets/furnishing_icons/PergoDomino-79X79.svg",
        category: "pergodomino",
        subCategory: "pergodomino_03",
        type: "PergoDomino",
        material: "plastica",
        width: 79,
        height: 79,
        widthCell: 3,
        heightCell: 3,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "pergodomino_03_metallo",
        name: "Pergodomino 03 79x79 h55 in Metallo",
        imageUrl: "/assets/furnishing_icons/PergoDomino-79X79.svg",
        category: "pergodomino",
        subCategory: "pergodomino_03",
        type: "PergoDomino",
        material: "metallo",
        width: 79,
        height: 79,
        widthCell: 3,
        heightCell: 3,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "pergodomino_04_plastica",
        name: "Pergodomino 04 79x79 h80 in Plastica",
        imageUrl: "/assets/furnishing_icons/PergoDomino-79X79.svg",
        category: "pergodomino",
        subCategory: "pergodomino_04",
        type: "PergoDomino",
        material: "plastica",
        width: 79,
        height: 79,
        widthCell: 3,
        heightCell: 3,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "pergodomino_04_metallo",
        name: "Pergodomino 04 79x79 h80 in Metallo",
        imageUrl: "/assets/furnishing_icons/PergoDomino-79X79.svg",
        category: "pergodomino",
        subCategory: "pergodomino_04",
        type: "PergoDomino",
        material: "metallo",
        width: 79,
        height: 79,
        widthCell: 3,
        heightCell: 3,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "domino_lights_incasso",
        name: "Domino Lights - Faretti a Incasso",
        imageUrl:
            "/assets/furnishing_icons/Faretti-Incasso.svg",
        category: "domino_lights",
        subCategory: "lights_incasso",
        type: "DominoLights",
        material: "acciaio_inox",
        width: 4.2,
        height: 4.6,
        widthCell: 1,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
    {
        id: "domino_lights_picchetto",
        name: "Domino Lights - Faretti a Picchetto",
        imageUrl:
            "/assets/furnishing_icons/Faretti-Picchetto.svg",
        category: "domino_lights",
        subCategory: "lights_picchetto",
        type: "DominoLights",
        material: "alluminio",
        width: 10,
        height: 14,
        widthCell: 1,
        heightCell: 1,
        rotationStates: ['t','r','b','l'],
    },
];

export const macroCategories = [
    {
        key: "panche_sedute",
        label: "Panche e Sedute",
        categories: ["exte", "cover", "seduta"],
    },
    {
        key: "pannelli_grigliati",
        label: "Pannelli e Grigliati per Verde Verticale",
        categories: ["pannelli_grigliati"],
    },
    {
        key: "telai_ruote",
        label: "Telai con Ruote",
        categories: ["telaio_ruote"],
    },
    {
        key: "pergo_domino",
        label: "PergoDomino",
        categories: ["pergodomino"],
    },
    // {
    //     key: "dominolights",
    //     label: "Domino Lights",
    //     categories: ["domino_lights"],
    // },
];

export const pancheSubCategories = [
    { key: "exte", label: "Panca Exte" },
    { key: "exte_ribassata", label: "Panca Exte Ribassata" },
    { key: "cover", label: "Panca Cover" },
    { key: "cover_skyline", label: "Panca Cover Skyline" },
    { key: "seduta", label: "Seduta con vano contenitore" },
    { key: "cassapanca", label: "Cassapanca con vano contenitore" },
];

export const telaiSubCategories = [
    { key: "ruote_visibili", label: "Telai con ruote" },
    { key: "ruote_scomparsa", label: "Telai con ruote a scomparsa" },
];

export const pannelliGrigliatiSubCategories = [
    { key: "pannello_frangivista", label: "Pannello Frangivista" },
    { key: "pannello_frangisole", label: "Pannello Frangisole" },
    { key: "supporti_vetro", label: "Supporti per pannello in vetro" },
    { key: "grigliati_fili", label: "Grigliati con fili acciaio inox" },
    { key: "grigliati_rete", label: "Grigliati con rete metallica acciaio inox" },
];

export const pergodominoSubCategories = [
    { key: "pergodomino_01", label: "Pergodomino 01 54x54 h55" },
    { key: "pergodomino_02", label: "Pergodomino 02 54x54 h80" },
    { key: "pergodomino_03", label: "Pergodomino 03 79x79 h55" },
    { key: "pergodomino_04", label: "Pergodomino 04 79x79 h80" },
];

// Pre-compute imageUrl properties for categories and subcategories
// Add imageUrl to macroCategories based on first variant of each category
macroCategories.forEach(macroCategory => {
    for (const categoryKey of macroCategory.categories) {
        const firstVariant = variants.find(variant => variant.category === categoryKey);
        if (firstVariant) {
            macroCategory.imageUrl = firstVariant.imageUrl;
            break;
        }
    }
});

// Add imageUrl to subcategories based on first variant of each subCategory
[pancheSubCategories, telaiSubCategories, pannelliGrigliatiSubCategories, pergodominoSubCategories].forEach(subCategoryArray => {
    subCategoryArray.forEach(subCategory => {
        const firstVariant = variants.find(variant => variant.subCategory === subCategory.key);
        if (firstVariant) {
            subCategory.imageUrl = firstVariant.imageUrl;
        }
    });
});